import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=4d622961&scoped=true"
import script from "./additional.vue?vue&type=script&lang=js"
export * from "./additional.vue?vue&type=script&lang=js"
import style0 from "./additional.vue?vue&type=style&index=0&id=4d622961&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d622961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d622961')) {
      api.createRecord('4d622961', component.options)
    } else {
      api.reload('4d622961', component.options)
    }
    module.hot.accept("./additional.vue?vue&type=template&id=4d622961&scoped=true", function () {
      api.rerender('4d622961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/additional.vue"
export default component.exports